export interface IUiState {
    isSideNavShrinked: boolean,
    showPageLoading: boolean,
    totalUnReadNotification: number,
}

export enum IUiConstants {
    TOGGLE_SIDE_NAV_SHRINK = 'TOGGLE_SIDE_NAV_SHRINK',
    SHOW_PAGE_LOADING = 'SHOW_PAGE_LOADING',
    HIDE_PAGE_LOADING = 'HIDE_PAGE_LOADING',
    TOTAL_UNREAD_NOTIFICATION = 'TOTAL_UNREAD_NOTIFICATION',
    SET_SIDE_NAV_SHRINK = 'SET_SIDE_NAV_SHRINK'
}

const init: IUiState = {
    isSideNavShrinked: false,
    showPageLoading: false,
    totalUnReadNotification: 0,
};

export function UiReducer(state: IUiState = init, action: any): IUiState {
    switch (action.type) {
        case IUiConstants.TOGGLE_SIDE_NAV_SHRINK:
            const isSideNavShrinked = !state.isSideNavShrinked;
            return {...state, isSideNavShrinked};
        case IUiConstants.SET_SIDE_NAV_SHRINK:
            return {...state, isSideNavShrinked: action.value};
        case IUiConstants.SHOW_PAGE_LOADING:
            return {...state, showPageLoading : true};
        case IUiConstants.HIDE_PAGE_LOADING:
            return {...state, showPageLoading : false};
        case IUiConstants.TOTAL_UNREAD_NOTIFICATION:
            return {...state, totalUnReadNotification : action.value};
        default:
            return state;
    }
}

export  class UiAction {
    toggleSideNavShrink = () => {
        return {type: IUiConstants.TOGGLE_SIDE_NAV_SHRINK}
    };

    setSideNavShrink = (value: boolean) => {
        return {type: IUiConstants.SET_SIDE_NAV_SHRINK, value: value}
    };

    showPageLoading = () => {
        return {type: IUiConstants.SHOW_PAGE_LOADING}
    };

    hidePageLoading = () => {
        return {type: IUiConstants.HIDE_PAGE_LOADING}
    };

    setTotalUnReadNotification = (value: number) => {
        return {type: IUiConstants.TOTAL_UNREAD_NOTIFICATION, value: value}
    };
}
